<ng-container *ngIf="nzShowExpand || nzIndentSize > 0">
  <ui-row-indent [indentSize]="nzIndentSize"></ui-row-indent>
  <button ui-row-expand-button [expand]="nzExpand" (expandChange)="onExpandChange($event)" [spaceMode]="!nzShowExpand"></button>
</ng-container>
<label ui-checkbox *ngIf="nzShowCheckbox" [uiDisabled]="nzDisabled" [ngModel]="nzChecked" [uiIndeterminate]="nzIndeterminate" (ngModelChange)="onCheckedChange($event)"></label>
<ng-content></ng-content>
